(function fileDetailControllerDefinition() {
    'use strict';

    angular.module('File')
        .controller('FileDocumentContainerDetailController', [
            '$scope', 'config', '$state', '$translate', '$stateParams', 'errorsExtend', 'fileService', 'storageService', 'documentContainerService', 'authExtend',
            function FileDocumentContainerDetailController($scope, config, $state, $translate, $stateParams, errors, fileService, storageService, documentContainerService, auth) {

                function detectIE() {
                    var ua = window.navigator.userAgent;

                    var msie = ua.indexOf('MSIE ');
                    if (msie > 0) {
                        // IE 10 or older => return version number
                        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
                    }

                    var trident = ua.indexOf('Trident/');
                    if (trident > 0) {
                        // IE 11 => return version number
                        var rv = ua.indexOf('rv:');
                        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
                    }

                    return false;
                };

                $scope.IsIe = detectIE();
                $scope.hasFilesSigned = false;
                $scope.hasFilesNotConverted = false;

                $scope.auditEntity = {
                    creationDate: new Date(),
                    userId: auth.getUserId(),
                    userName: auth.getUserNick(),
                    applicationId: config.appId(),
                    applicationName: config.appName(),
                    organizationalUnitId: auth.getOrganizationId(),
                    organizationalUnitName: auth.getOrganizationName(),
                    actionType: { id: 37 }//FileDownLoad
                };
                                
                $scope.docu = {
                    documentTypes: [],
                    accordionIsOpen: false,
                    filesAccordionIsOpen: false,
                    hasMetadata: false
                };

                $scope.cancel = function () {
                    $state.goBack('inicio');
                };

                $scope.initDocumentFind = function () {
                    if ($scope.urlFind) {
                        $state.go($scope.urlFind);
                    }
                };

                $scope.fileNames = [];

                $scope.load = function () {
                    $scope.urlFind = storageService.getStateBackFind();
                    $scope.hasBack = $state.hasPrevious();

                    $scope.viewPdf(false);
                }

                $scope.viewAll = function () {
                    $scope.content = undefined;
                    $scope.file = undefined;
                    return $scope.viewPdf(true);
                }

                $scope.viewPdf = function (viewAll) {
                    return fileService.getDocumenContainer($stateParams.id).then(function (result) {
                        if (result.base64File !== '') {
                            $scope.content = 'data:application/pdf;base64,' + result.base64File;
                            $scope.file = result;
                            $scope.documentsId = result.documentsId;
                            $scope.hasFilesNotConverted = $scope.file.filesNotConverted.length > 0;

                            $scope.auditEntity.entity = JSON.stringify({
                                documentsId: $scope.documentsId,
                                fileDownloadedBy: auth.getUserNick(),
                                fileDownloadedDate: new Date(),
                                organizationalUnit: auth.getOrganizationId(),

                            });
                            $scope.auditEntity.keys = [];
                            $scope.documentsId.forEach(function (did) {
                                $scope.auditEntity.keys.push({ key: "DOCUMENT", value: did })
                            });

                            
                            if ($scope.file.fileNames != null) {
                                $scope.file.fileNames.forEach(function (name) {
                                    var fileData = {};
                                    fileData.name = name.key;
                                    fileData.isSigned = name.value;

                                    if (fileData.isSigned) {
                                        $scope.hasFilesSigned = true;
                                    }

                                    function isContainedBy(element, index, array) {
                                        return fileData.name.indexOf(element) != -1;
                                    }

                                    if (result.filesNotConverted.some(isContainedBy)) {
                                        fileData.IsNotConverted = true;
                                    }
                                    $scope.fileNames.push(fileData);
                                })
                            }
                            var tempVersion = true;

                            if ($scope.urlFind === 'document-advanced-find') {
                                tempVersion = false;
                            }

                            $translate(['FileContainerDetail']).then(function (translated) {
                                $scope.title = translated.FileContainerDetail + $scope.file.name;
                            });
                        }
                        else {
                            if (result.filesNotConverted && result.filesNotConverted.length > 0) {
                                errors.showWarning('AllFilesNotConverted');
                            }
                            else {
                                errors.showWarning('The document has no files');
                            }
                            $scope.cancel();
                        }
                    }, function (error) {
                        if (error.status === 204) {
                            errors.showWarning('The document has no files');
                        } else {
                            errors.showError(error);
                        }
                        $scope.cancel();
                    });
                }

                $scope.metadataCount = function (document) {
                    if (document.documentTypes && document.documentTypes.length) {
                        return document.documentTypes.reduce(function (valorPrevio, valorActual, indice, array) { return valorPrevio + valorActual.metadatas.length; }, 0);
                    }
                    return 0;
                };

                $scope.toggleAccordion = function () {
                    if ($scope.docu.accordionIsOpen) {
                        $scope.fillDocMetadata();
                    }
                };

                $scope.fillDocMetadata = function () {

                    if ($scope.docu.documentTypes.length === 0) {

                        return $scope.getMetadata(false).then(function (result) {

                        }, function (error) {
                            errors.showError(error);
                            $scope.cancel();
                        });
                    }
                }

                $scope.getMetadata = function () {
                    return documentContainerService.getById($stateParams.id).then(function (result) {
                        $scope.docu.documentTypes = [];
                        var dt = {
                            metadatas: result.metadatas
                        };

                        $scope.docu.documentTypes.push(dt);

                        $scope.docu.documentTypes.forEach(function (docType) {
                            docType.metadatas.sort(function (a, b) {
                                return a.position - b.position;
                            });
                        });

                        $scope.docu.hasMetadata = ($scope.metadataCount($scope.docu) !== 0);


                        $scope.auditEntity.entity = JSON.stringify({
                            documentId: $scope.file.documentVersionDocumentId,
                            documentTypeName: $scope.docu.documentTypes[0].documentTypeName,
                            documentName: $scope.file.documentVersionName,
                            fileDownloadedBy: auth.getUserId(),
                            fileDownloadedDate: new Date(),
                            organizationalUnit: auth.getOrganizationId(),
                            metadatas: $scope.docu.documentTypes[0].metadatas.map(function (obj) {
                                var rObj = {};
                                rObj[obj.systemName] = obj.metadataValue;
                                return rObj;
                            })
                        });
                    });
                };

                $scope.load();
            }
        ]);
})();